module.exports = __webpack_public_path__ + "img/warning-outline.78bf669f.svg";